import { createContext } from 'react'

const FormCtx = createContext()

export default FormCtx
